import { render, staticRenderFns } from "./FormRating.vue?vue&type=template&id=41322def&scoped=true"
import script from "./FormRating.vue?vue&type=script&lang=ts"
export * from "./FormRating.vue?vue&type=script&lang=ts"
import style0 from "./FormRating.vue?vue&type=style&index=0&id=41322def&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41322def",
  null
  
)

export default component.exports